import { render, staticRenderFns } from "./CreateAnotation.vue?vue&type=template&id=2130e4e4&"
import script from "./CreateAnotation.vue?vue&type=script&lang=js&"
export * from "./CreateAnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports